<app-floor-header></app-floor-header>
<div class="park-place-content" [ngClass]="{ mobile: isMobile }">
    <app-floor-map></app-floor-map>
</div>
